"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _PublicAvailabilityInfo = _interopRequireDefault(require("MeetingsBase/models/PublicAvailabilityInfo"));

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _handleActions;

var initialState = new _PublicAvailabilityInfo.default();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED), function (state, action) {
  return action.payload.bookInfo;
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.BOOKING_TIME_CONFLICT, function (state, action) {
  return state.updateBusyTime(action.payload.userBusyTimes);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;